import { render, staticRenderFns } from "./card_fila.vue?vue&type=template&id=401a06d6&scoped=true&"
import script from "./card_fila.vue?vue&type=script&lang=js&"
export * from "./card_fila.vue?vue&type=script&lang=js&"
import style0 from "./card_fila.vue?vue&type=style&index=0&id=401a06d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a06d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VListItemSubtitle})
